import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useMemo, useState } from "react";

const cardStyle = "p-3 w-full flex flex-col gap-3 items-center bg-[#0D2436]";
const DesktopHowItWorks = () => {
  const [index, setIndex] = useState(0);

  const content = useMemo(
    () => [
      <div className={`${cardStyle}`}>
        <img
          src="https://img.learntube.ai/public-assets/New%20Landing%20Page/thumbsup.svg?updatedAt=1744185899171"
          width={21}
          height={21}
          alt=""
          className="mx-auto"
        />
        <div className="leading-[130%]">
          <p>Gain</p>
          <p>Recognition</p>
        </div>
      </div>,
      <div className={`${cardStyle}`}>
        <img
          src="https://img.learntube.ai/public-assets/New%20Landing%20Page/increase-salary.svg?updatedAt=1744179161219"
          width={16}
          height={21}
          alt=""
          className="mx-auto"
        />
        <div className="mt-2 leading-[130%]">
          <p>Increase Salary</p>
          <p className="font-bold text-white">up to 150%</p>
        </div>
      </div>,
      <div className={`${cardStyle}`}>
        <img
          src="https://img.learntube.ai/public-assets/New%20Landing%20Page/job-chance.svg?updatedAt=1744186634910"
          width={18}
          height={21}
          alt=""
        />
        <div className="leading-[130%]">
          <p>
            <span className="font-bold text-white">3x</span> your Job
          </p>
          <p>Chances</p>
        </div>
      </div>,
      <div className={`${cardStyle}`}>
        <img
          src="https://img.learntube.ai/public-assets/New%20Landing%20Page/Group_3.svg?updatedAt=1744186835820"
          width={21}
          height={21}
          alt=""
        />
        <div className="leading-[130%]">
          <p>Get Noticed by</p>
          <p>Employers</p>
        </div>
      </div>,
    ],
    [],
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % content.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [content.length]);

  return (
    <div className="mt-4 flex h-[164px] items-center justify-center gap-[40px] overflow-clip rounded-3xl bg-[#0D2436] py-8 px-4 pl-6">
      <h2
        className="text-left text-2xl font-semibold text-[#D5EDFF]"
        style={{
          textShadow: "0px 0px 3px rgba(255, 255, 255, 0.4)",
        }}
      >
        How it Works?
      </h2>
      <div className="flex items-center gap-6">
        <div className="relative z-20 flex items-center">
          <div className="flex h-[136px] w-[136px] flex-col items-center justify-center rounded-full border-[6px] border-[#006FBC]/20 bg-[#0E4771] px-2 text-[15px] text-[#83BEFF]">
            <img
              src="https://img.learntube.ai/public-assets/New%20Landing%20Page/Quiz%201.svg?updatedAt=1744179014975"
              width={31.5}
              height={31.5}
              alt=""
            />
            <p>Pass a Quick</p>
            <p>Test</p>
          </div>
        </div>
        <div className="relative flex items-center justify-center">
          <img
            src="https://img.learntube.ai/public-assets/New%20Landing%20Page/down-arrow.svg?updatedAt=1744184923146"
            width={18}
            height={21}
            className="z-20 -rotate-90"
            alt=""
          />
          <div className="z-20 flex h-[156px] w-[156px] flex-shrink-0 flex-col items-center justify-center rounded-full border-[10px] border-[#006FBC]/20 bg-[#08578F] px-1 text-[15px] text-[#83BEFF]">
            <img
              src="https://img.learntube.ai/public-assets/New%20Landing%20Page/Certificate%201.svg?updatedAt=1744181188447"
              width={33}
              height={31.5}
              alt=""
            />
            <p className="mt-3">Unlock Instant</p>
            <p>Certificate</p>
          </div>
          <img
            src="https://img.learntube.ai/public-assets/New%20Landing%20Page/down-arrow.svg?updatedAt=1744184923146"
            width={18}
            height={21}
            className="z-20 -rotate-90"
            alt=""
          />
          <div className="absolute left-1/2 z-0 h-[226.5px] w-[228px] -translate-x-1/2">
            <motion.img
              src="https://img.learntube.ai/public-assets/New%20Landing%20Page/Group%2022973.png?updatedAt=1744727963291"
              className="h-full w-full"
              alt=""
              animate={{ rotate: -360 }}
              transition={{
                repeat: Infinity,
                duration: 12,
                ease: "linear",
              }}
            />
          </div>
          <div className="absolute left-1/2 z-0 h-[364.5px] w-[364px] -translate-x-1/2">
            <motion.img
              src="https://img.learntube.ai/public-assets/New%20Landing%20Page/bigger-circle.png?updatedAt=1744727963586"
              className="h-full w-full"
              alt=""
              animate={{ rotate: -360 }}
              transition={{
                repeat: Infinity,
                duration: 12,
                ease: "linear",
              }}
            />
          </div>
          <div
            className="absolute left-1/2 z-10 h-[364.5px] w-[364px] -translate-x-1/2"
            style={{
              backgroundImage:
                "linear-gradient(to right, rgba(13, 36, 54, 1) 0%, rgba(13, 36, 54, 0) 100%)",
            }}
          ></div>
        </div>
        <div className="relative h-[164px] w-[135px] overflow-hidden">
          <AnimatePresence mode="wait">
            <motion.div
              key={index}
              initial={{ y: 100, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -120, opacity: 0 }}
              transition={{ duration: 1 }}
              className="absolute inset-0 flex items-center justify-center text-center text-[15px] text-[#83BEFF]"
            >
              {content[index]}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export default DesktopHowItWorks;
